<template>
  <div class="app-container">
    <div class="filter-container">
      <el-date-picker v-model="dateArr" type="datetimerange" :default-time="['00:00:00','23:59:59']" align="right" value-format="yyyy-MM-dd HH:mm:ss" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" class="filter-item" style="display: inline-flex;"></el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>
    <div class="amount"><div class="flex"><span>￥</span>总充值金额: {{total_recharge}} 全豆</div></div>
    <div class="amount"><div class="flex"><span>￥</span>总VIP付费: {{total_vip}} 全豆</div></div>
    <div class="amount"><div class="flex"><span>￥</span>课程总收入: {{total_course}} 全豆</div></div>
    <div class="amount"><div class="flex"><span>￥</span>课程已使用优惠: {{total_discount_course}} 全豆</div></div>
    <div class="amount"><div class="flex"><span>￥</span>活动总收入: {{total_activity}} 全豆</div></div>
    <div class="amount"><div class="flex"><span>￥</span>活动已使用优惠: {{total_discount_activity}} 全豆</div></div>
    <div class="amount"><div class="flex"><span>￥</span>用户余额: {{total_user_balance}} 全豆</div></div>
    <el-table
            v-loading="listLoading"
            :data="list"
            element-loading-text="Loading"
            border
            fit
            highlight-current-row>
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?scope.row.user.nickname:'' }}
        </template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img v-if="scope.row.user && scope.row.user.avatar" :src="scope.row.user.avatar" class="user-avatar">
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?scope.row.user.phone:'' }}
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">充值</span>
          <span v-else-if="scope.row.type == 2">提现</span>
          <span v-else-if="scope.row.type == 3">签到</span>
          <span v-else-if="scope.row.type == 4">课程购买</span>
          <span v-else-if="scope.row.type == 5">活动报名</span>
          <span v-else-if="scope.row.type == 6">购买或续费会员</span>
          <span v-else-if="scope.row.type == 7">活动退款</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_payout == 1" type="success">收入</el-tag>
          <el-tag v-else type="danger">支出</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="全豆" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.whole_bean }}
        </template>
      </el-table-column>
      <el-table-column label="时间" min-width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script>

  import request from '@/utils/request'

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        dateArr: null,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        listQuery: {
          page: 1,
          limit: 10,
          start_datetime: '',
          end_datetime: '',
        },
        total_recharge:'',
        total_vip:'',
        total_course:'',
        total_user_balance:'',
        total_discount_course:'',
total_activity:'',
total_discount_activity:'',
      }
    },
    created() {
      this.getUserAccountLog()
      this.getDataCount()
    },
    watch: {
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_datetime = newVal[0];
          this.listQuery.end_datetime = newVal[1];
        } else {
          this.listQuery.start_datetime = "";
          this.listQuery.end_datetime = "";
        }
      }
    },
    methods: {
      getUserAccountLog() {
        this.listLoading = true
        request({
          url: '/api/backend/finance/userAccountLog',
          method: 'get',
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data
          this.total = response.data.total
          this.listLoading = false
        })
      },
      getDataCount() {
        this.listLoading = true
        request({
          url: '/api/backend/finance/dataCount',
          method: 'get',
          params: this.listQuery
        }).then(response => {
          this.total_recharge = response.data.total_recharge
          this.total_vip = response.data.total_vip
          this.total_course = response.data.total_course
          this.total_user_balance = response.data.total_user_balance
          this.total_discount_course = response.data.total_discount_course
          this.total_activity = response.data.total_activity
          this.total_discount_activity = response.data.total_discount_activity
          this.listLoading = false
        })
      },
      handleFilter() {
        this.listQuery.page = 1
        this.getUserAccountLog()
        this.getDataCount()
      },
      handleSizeChange(val) {
        this.listQuery.limit = val
        this.getUserAccountLog()
        this.getDataCount()
      },
      handleCurrentChange(val) {
        this.listQuery.page = val
        this.getUserAccountLog()
        this.getDataCount()
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .amount {
    display: inline-block;
    padding: 20px 30px;
    margin-bottom: 20px;
    margin-right: 20px;
    color: #ffffff;
    background-color: rgba(255, 0, 0, 0.438);
    border-radius: 40px;
    .flex{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      span{
        font-size: 30px;
        font-weight: bold;
      }
    }
  }
</style>
